import { Button, Flex, IconSaveLine, Spinner } from "@instructure/ui";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import { ExternalService } from "../../../../../services/ExternalService";
import { fileWriter } from "../../../../../utils/FileUtils";
import {
  ERROR,
  useNotification,
} from "../../../../CustomHooks/NotificationProvider";
import RichTextEditor from "../../../../RichTextArea/RichTextEditor";
import RichTextViewer from "../../../../RichTextArea/RichTextViewer";

const Recommendations = ({ id, label, permission }) => {
  const { t } = useTranslation();
  const showNotification = useNotification();
  const [recommendations, setRecommendations] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    ExternalService.getFileContent("response.html", "recommendations", id)
      .then((res) => {
        if (res.content === "" && !permission) {
          setRecommendations(
            "<p><em>No recommendations have been submitted yet.</em></p>"
          );
        } else {
          setRecommendations(res.content);
        }
      })
      .catch(() =>
        showNotification(
          t("notifications.assessmentResults.getRecommendationError"),
          ERROR
        )
      );
  }, [id, permission, showNotification]);

  const handleSaveRecs = async (id, content) => {
    setSaving(true);
    try {
      const rec = fileWriter(content, "response.html", "text/html");
      await ExternalService.saveFile(rec, "recommendations", id);
      showNotification(
        t("notifications.assessmentResults.addRecommendationSuccess")
      );
    } catch {
      showNotification(
        t("notifications.assessmentResults.addRecommendationError"),
        ERROR
      );
    } finally {
      setSaving(false);
    }
  };

  return recommendations !== null ? (
    <Flex wrap="wrap">
      <Flex.Item size="100%">
        {permission ? (
          <RichTextEditor
            id={id}
            label={label}
            defaultValue={recommendations}
            onChange={(value) => setRecommendations(value)}
          />
        ) : (
          <RichTextViewer id={id} label={label} value={recommendations} />
        )}
      </Flex.Item>
      {permission && (
        <Flex.Item shouldGrow textAlign="end">
          <Button
            margin="small 0 0 0"
            color="primary"
            size="small"
            onClick={() => handleSaveRecs(id, recommendations)}
            disabled={saving}
            renderIcon={
              saving ? (
                <Spinner renderTitle={t("global.pleaseWait")} size="x-small" />
              ) : (
                IconSaveLine
              )
            }
          >
            {t("results.saveRecommendations")}
          </Button>
        </Flex.Item>
      )}
    </Flex>
  ) : (
    <Skeleton height="10rem" />
  );
};

export default Recommendations;
